import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	padding: 2rem 1.5rem 3rem;
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 0.5rem;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		grid-template-columns: repeat(6, 1fr);
	}
`;

const Tile = styled.a`
	position: relative;
	color: white;
	text-decoration: none;
`;

const Overlay = styled.span`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.6);
	opacity: 0;
	transition: opacity 200ms ease;
`;

const TileInner = styled.div`
	&:hover ${Overlay} {
		opacity: 1;
	}
`;

const ViewAll = styled.a`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.75rem;
	margin: 1rem auto 0;
	text-transform: uppercase;
	font-weight: 500;
`;

export default function GalleryBlockEpsilon({ photos }: { photos: MicrositeResponsiveImage[] }) {
	if (photos.length === 0) return null;

	return (
		<Section id="photos">
			<Grid>
				{photos.map((photo, index) => (
					<Tile key={index} href="#gallery" data-index={index}>
						<TileInner>
							<MicrositeResponsiveImg image={photo} priority={LoadPriority.FIRST_PAINT} />
							<Overlay>View</Overlay>
						</TileInner>
					</Tile>
				))}
			</Grid>
			<ViewAll href="#gallery">View All {photos.length} Photos</ViewAll>
		</Section>
	);
}
